import React from 'react';
import map from 'lodash/map';
import { useTranslation } from 'react-i18next';

import { Select } from 'formlabs-web-components/Form';

const companySizes = {
  10: '1-10',
  50: '11-50',
  200: '51-200',
  500: '201-500',
  1000: '501-1,000',
  5000: '1,001-5,000',
  10000: '5,001-10,000',
  10001: '10,001+'
};

const CompanySizeSelect = props => {
  const { t } = useTranslation();

  return (
    <Select {...props}>
      <option value="">– {t('Select')} –</option>
      <option value="1">{t('Self-employed')}</option>
      {map(companySizes, (value, key) => (
        <option key={key} value={key}>
          {t('{{quantity}} employees', { quantity: value })}
        </option>
      ))}
    </Select>
  );
};

CompanySizeSelect.defaultProps = { defaultValue: '' };
export default CompanySizeSelect;
